import axios from 'axios';

export const wmsApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

wmsApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Obtener el total de piezas de un producto en inventario
export const getTotalPiezasProducto = async (producto_id) => {
  const response = await wmsApi.get(`/api/v1/wms/inventario/producto/${producto_id}/total`);
  return response.data;
};

// Consulta de inventario por SKU, ubicación o código de barras (EAN/UPC)
export const consultarInventario = async ({ sku, ubicacion, codigo_barras }) => {
  let url = '/api/v1/wms/inventario/consulta?';
  if (sku) url += `sku=${encodeURIComponent(sku)}&`;
  if (ubicacion) url += `ubicacion=${encodeURIComponent(ubicacion)}&`;
  if (codigo_barras) url += `codigo_barras=${encodeURIComponent(codigo_barras)}&`;
  const response = await wmsApi.get(url);
  return response.data;
};

// Registrar movimiento de inventario (put away)
export const registrarMovimientoInventario = async (movimientos) => {
  // movimientos: array de { producto_id, cantidad, origen_id, destino_id, lote, estado_calidad, usuario_id }
  const response = await wmsApi.post('/api/v1/wms/inventario/movimiento', movimientos);
  return response.data;
};

// Consultar movimientos de inventario
export const consultarMovimientosInventario = async (filtros = {}) => {
  let url = '/api/v1/wms/inventario/movimientos?';
  if (filtros.producto_id) url += `producto_id=${encodeURIComponent(filtros.producto_id)}&`;
  if (filtros.cliente_id) url += `cliente_id=${encodeURIComponent(filtros.cliente_id)}&`;
  if (filtros.tipo) url += `tipo=${encodeURIComponent(filtros.tipo)}&`;
  if (filtros.fecha_inicio) url += `fecha_inicio=${encodeURIComponent(filtros.fecha_inicio)}&`;
  if (filtros.fecha_fin) url += `fecha_fin=${encodeURIComponent(filtros.fecha_fin)}&`;
  const response = await wmsApi.get(url);
  return response.data;
};

// Actualizar el HU de un inventario
export const actualizarInventarioHU = async (inventario_id, hu_id) => {
  const response = await wmsApi.patch(`/api/v1/wms/inventario/${inventario_id}/hu`, { hu_id });
  return response.data;
};

// Consulta de inventario individual (para putaway por HU)
export const consultarInventarioIndividual = async ({ sku, ubicacion, codigo_barras, cliente_id }) => {
  let url = '/api/v1/wms/inventario/lista?';
  if (sku) url += `sku=${encodeURIComponent(sku)}&`;
  if (ubicacion) url += `ubicacion=${encodeURIComponent(ubicacion)}&`;
  if (codigo_barras) url += `codigo_barras=${encodeURIComponent(codigo_barras)}&`;
  if (cliente_id) url += `cliente_id=${encodeURIComponent(cliente_id)}&`;
  const response = await wmsApi.get(url);
  return response.data;
};

// Consulta de inventario agrupado con IDs (para putaway por HU)
export const consultarInventarioAgrupadoConIds = async ({ sku, ubicacion, codigo_barras, cliente_id }) => {
  let url = '/api/v1/wms/inventario/agrupado_con_ids?';
  if (sku) url += `sku=${encodeURIComponent(sku)}&`;
  if (ubicacion) url += `ubicacion=${encodeURIComponent(ubicacion)}&`;
  if (codigo_barras) url += `codigo_barras=${encodeURIComponent(codigo_barras)}&`;
  if (cliente_id) url += `cliente_id=${encodeURIComponent(cliente_id)}&`;
  const response = await wmsApi.get(url);
  return response.data;
};
